import find from 'lodash/find'
import map from 'lodash/map'
import memoize from 'lodash/memoize'

function getNodeData(node) {
    return {
        name: node.id,
        bBox: node.getBBox(),
        pathData: node.getAttribute('d'),
        node: node
    };
}

function getAllCustomIcons() {
    let iconNodes = document.querySelectorAll('[id^=\'custom-icon-\']');
    return (iconNodes.length) ? map(iconNodes, getNodeData) : null;
}

export default function getCustomIcon(name) {
    var getAllCustomIconsMemoized = memoize(getAllCustomIcons);
    return find(getAllCustomIconsMemoized(), i => i.name === name);
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/seats/getCustomIcon.js